<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :data="tableResourcePriceCoefficientDate" style="width: 100.1%;">
      <template slot-scope="{row,index}" slot="detail">
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="resourcePriceCoefficientDelModal = true">{{$t('resourceLifecycle.delete')}}</Button>
                </span>
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="resourcePriceCoefficientDelModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
      </p>
      <div style="text-align:center">
        <p>{{$t('alarms.common.sureDelete')}}</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long :loading="modal_loading" @click="removeResourcePriceCoefficient()" :disabled="isDisable">{{ $t('ticket.list.delete') }}</Button>
      </div>
    </Modal>
    <!-- 编辑模式框 -->
    <Modal v-model="modal" title="编辑资源价格系数" :loading="loading" :mask-closable="false" :styles="{top:'65px'}">
      <Form ref="resourcePriceCoefficientForm" :model="resourcePriceCoefficientForm" :label-width="100" :rules="ruleValidate">
        <!-- 公司 -->
        <FormItem :label="$t( 'resourceLifecycle.incorporation' )" prop="company">
          <div>{{company}}</div>
        </FormItem>

        <!-- 云平台 -->
        <FormItem :label="$t( 'resourceLifecycle.cloudPlatform' )" prop="platform">
          <Select v-model="resourcePriceCoefficientForm.platform" filterable style="width:300px;">
            <Option :value="item.id" v-for="item in platformList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 资源类型 -->
        <FormItem :label="$t( 'resourceLifecycle.resourceType' )" prop="resourceType">
          <Select v-model="resourcePriceCoefficientForm.resourceType" filterable :placeholder="$t( 'resourceLifecycle.filterbyresourcetype' )" :transfer="true" style="width300px;">
            <Option :value="item.id" v-for="item in resourceTypeList" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 系数 -->
        <FormItem :label="$t( 'resourceLifecycle.coefficients' )" prop="coefficient">
          <InputNumber v-model="resourcePriceCoefficientForm.coefficient" style="width:300px;"></InputNumber>
        </FormItem>

        <!-- 描述 -->
        <FormItem :label="$t( 'resourceLifecycle.picturing' )" prop="remark">
          <Input v-model="resourcePriceCoefficientForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
        </FormItem>

        <!-- todo  最后价格
        <FormItem :label="$t( 'resourceLifecycle.lastPrice' )">
            <div>￥{{lastPrice}}</div>
        </FormItem>
         -->
      </Form>
      <div slot="footer">
        <Button @click="resourcePriceCoefficientReset('resourcePriceCoefficientForm')">{{$t('ticket.list.cancel')}}</Button>
        <Button type="primary" @click="resourcePriceCoefficientSubmit('resourcePriceCoefficientForm')">{{$t('ticket.list.confirm')}}</Button>
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>
  </div>
</template>
<script>
  var tableResourcePriceCoefficientVue = {};
  export default {
    name: 'TableResourcePriceCoefficient',
    data () {
      return {
        lastPrice: '',
        company: '',
        platformList: [
          {
            id:0,
            name:'AWS'
          },{
            id:2,
            name:'Azure'
          }
        ],
        resourceTypeList: [
          {
            id: 0,
            name: this.$t( 'resourceLifecycle.vMs' )
          },
          {
            id: 1,
            name: this.$t( 'resourceLifecycle.virtualNetwork' )
          },
          {
            id: 2,
            name: this.$t( 'resourceLifecycle.objectstorage' )
          },
          {
            id: 3,
            name: this.$t( 'resourceLifecycle.manageddatabase' )
          },
          {
            id: 4,
            name: this.$t( 'resourceLifecycle.elasticIP' )
          },
          {
            id: 5,
            name: this.$t( 'resourceLifecycle.azureMySQLServer' )
          },
          {
            id: 6,
            name: this.$t( 'resourceLifecycle.azureMariaDBServer' )
          },
          {
            id: 7,
            name: this.$t( 'resourceLifecycle.azureRedisServer' )
          }
        ],
        resourcePriceCoefficientForm: {
          platform: null,
          resourceType:null,
          coefficient:null,
          remark: ''
        },
        loading: true,
        modal:false,//编辑
        modal_loading: false,
        resourcePriceCoefficientDelModal:false,
        isDisable: false,//删除
        platform:'',
        current:1,
        dataTotal:0,
        pageSize:10,
        ruleValidate: {
          platform: [
            { required: true, message: this.$t( 'resourceLifecycle.pleaseselectthecloudplatform' ), trigger: 'change',type:'number'  }
          ],
          resourceType: [
            { required: true, message: this.$t( 'resourceLifecycle.pleaseselecttheresourcetype' ), trigger: 'change',type:'number'  }
          ],
          coefficient: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseenterthecoefficient' ), trigger: 'blur', type: 'number'}
          ],
          remark: [
            { required: true, message: this.$t( 'resourceLifecycle.pleaseenteradescription' ), trigger: 'blur'}
          ]
        },
        columns: [
          {
            title: this.$t( 'resourceLifecycle.companyName' ),
            key: 'companyName',
            render: (h,params) => {
              return h('a',{
                style: {
                  textDecoration: 'underline'
                },
                on: {
                  click: () => {
                    this.modal=true;
                    this.resourcePriceCoefficientForm.id = params.row.id;

                    //公司
                    this.company = params.row.companyName;
                    // 云平台
                    this.resourcePriceCoefficientForm.platform = params.row.platform;
                    this.resourcePriceCoefficientForm.resourceType = params.row.lifecycleResourceType;
                    this.resourcePriceCoefficientForm.coefficient = params.row.adjustCoefficient;
                    this.resourcePriceCoefficientForm.remark = params.row.remark;
                  }
                }
              },params.row.companyName);
            }
          },
          {
            title: this.$t( 'resourceLifecycle.cloudPlatform' ),
            key: 'platformDesc'
          },
          {
            title: this.$t( 'resourceLifecycle.resourceType' ),
            key: 'lifecycleResourceTypeDesc'
          },
          {
            title: this.$t( 'resourceLifecycle.coefficients' ),
            key: 'adjustCoefficient'
          },
          {
            title: this.$t( 'resourceLifecycle.picturing' ),
            key: 'remark'
          },
          {
            title: this.$t('common.operation'),
            slot: 'detail',
            width:210
          }],
        tableResourcePriceCoefficientDate: []
      }
    },
    beforeCreate: function() {
      tableResourcePriceCoefficientVue = this
    },
    mounted: function(){
      tableResourcePriceCoefficientVue.getData();
    },
    methods:{
      showAll: function(){
        tableResourcePriceCoefficientVue.getData();
      },
      // 分页显示数据
      /****************************************************/
      getData: function(){
        //获取ResourcePriceCoefficientSearch里面的搜索内容
        eventBus.$on('platform',function(val){
          tableResourcePriceCoefficientVue.platform = val;
        })
        // 查询
        this.$api.lifecycleResourcePriceAdjustment.page({
          "pageNum": this.current,
          "pageSize": this.pageSize,
          "platform": tableResourcePriceCoefficientVue.platform
        })
          .then(res => {
            if (res.data != null && res.data != undefined){
              this.tableResourcePriceCoefficientDate = res.data.records;
            }
          })
      },
      changePage: function(current){
        this.current=current;
        tableResourcePriceCoefficientVue.getData();
      },
      changeSize: function(pageSize){
        this.pageSize=pageSize;
        tableResourcePriceCoefficientVue.getData();
      },
      // 销毁caseSearchID
      beforeDestroy: function(){
        eventBus.$off('platform');
      },
      // 删除
      /****************************************************/
      doDelete: function(index){
        this.lineIndex=index;
      },
      removeResourcePriceCoefficient: function(){
        this.isDisable = true;  //开始可以点击
        var lineIndex=this.lineIndex;
        //案例删除
        this.$api.lifecycleResourcePriceAdjustment.delete("id",this.tableResourcePriceCoefficientDate[lineIndex].id)
          .then(res => {
            this.modal_loading = true;
            setTimeout(() => {
              // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
              //21条  3页  2*10+1时删除
              if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                this.current=this.current-1;
              }
              this.dataTotal=this.dataTotal-1;
              tableResourcePriceCoefficientVue.showAll();
              this.isDisable = false;
              this.modal_loading = false;
              this.resourcePriceCoefficientDelModal = false;
              this.$Message.success(this.$t("resourceLifecycle.response.deleteSuccess"));
            }, 1000);
          })
      },
      // 确定
      resourcePriceCoefficientSubmit: function(name){
        this.$refs[name].validate(valid => {
          if(valid){
            // 编辑
            this.$api.lifecycleResourcePriceAdjustment.update({
              "id": this.resourcePriceCoefficientForm.id,
              "platform": this.resourcePriceCoefficientForm.platform,
              "lifecycleResourceType": this.resourcePriceCoefficientForm.resourceType,
              "adjustCoefficient": this.resourcePriceCoefficientForm.coefficient,
              "remark": this.resourcePriceCoefficientForm.remark
            })
              .then(res => {
                setTimeout(() => {
                  tableResourcePriceCoefficientVue.getData();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t("resourceLifecycle.response.editSuccess"));
                  this.modal = false;
                },1000);
              })
          }else{
            //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t("resourceLifecycle.response.editFail"));
          }
        });
      },
      resourcePriceCoefficientReset: function(name){
        this.modal = false;
        this.$refs[name].resetFields();
      }
    }
  }
</script>
<style>
  .ivu-page
  {
    margin-top: 10px !important;
    margin-bottom: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_operation_report/resource_price_coefficient/TableResourcePriceCoefficient.vue